// import PhotoSwipe from 'photoswipe';
// import photoswipeSimplify from 'photoswipe-simplify';

// new PhotoSwipe;
// photoswipeSimplify.init();